<template>
  <div class="py-2 bg-white mx-2 rounded-4 text-start my-2">
    <div class="text-center w-100 dropdown-option-items" :style="packageDetails.length > 2 ? 'height:200px' : ''">
      <table class="table table-borderless mb-0">
        <tbody>
          <td class="px-2" v-if="unifiedPackageDetails.length">
            <table class="table text-end">
              <thead class="bg-light text-secondary">
                <th class="text-start ps-2">
                  Package
                </th>
                <th class="pe-2">
                  Unified Credits
                </th>
              </thead>
              <tr v-for="pack in unifiedPackageDetails" :key="pack">
                <td class="text-start ps-2">
                  {{ pack.packageName }}
                </td>
                <td class="pe-2">
                  {{ (pack.currency ?? '') + " " + Math.round(pack.credits * 100) / 100 }}
                </td>
              </tr>
            </table>
          </td>
          <tr v-for="pack in nonUnifiedPackageDetails" :key="pack">
            <td class="py-0">
              <table class="table text-secondary text-end pe-2">
                <thead class="bg-light text-dark">
                  <th colspan="2" class="text-start px-2">
                    {{ pack.packageName ?? "-" }}
                  </th>
                </thead>
                <tr>
                  <td class="text-start">
                    <li class="fa fa-comment"></li>
                    SMS
                  </td>
                  <td class="px-2">{{ pack.smsCredits }}</td>
                </tr>
                <tr>
                  <td class="text-start">
                    <li class="fa fa-envelope"></li>
                    Email
                  </td>
                  <td class="px-2">{{ pack.emailCredits }}</td>
                </tr>
                <tr>
                  <td class="text-start">
                    <li class="fa fa-whatsapp"></li>
                    Whatsapp
                  </td>
                  <td class="px-2">{{ pack.whatsappCredits }}</td>
                </tr>
                <tr>
                  <td class="text-start">
                    <li class="fa fa-comment-o"></li>
                    MMS
                  </td>
                  <td class="px-2">{{ pack.mmsCredits }}</td>
                </tr>
                <tr>
                  <td class="text-start">
                    <li class="fa fa-phone"></li>
                    Voice
                  </td>
                  <td class="px-2">{{ pack.mmsCredits }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr class="mb-1 mt-0 mx-3" />
    <div data-v-01b96e43="" class="text-center fw-bolder w-100">
      <router-link v-if="billingPermissionEnabled" data-v-01b96e43="" class="btn btn-sm"
        :to="`/${selectedBrand?.uri}/billing/usage`">
        Store Credits &nbsp; <i class="fa fa-external-link"></i>
      </router-link>
      <button v-else type="button" class="btn btn-sm" @click="packageDialog = true">
        Store Credits &nbsp; <i class="fa fa-info-circle"></i>
      </button>
    </div>
  </div>
  <fr-modal :value="packageDialog" @cancel="packageDialog = false" @hidden="packageDialog = false" :noPaddingBody="true"
    :verticalCentered="false" :showFooter="false" :xlarge="true">
    <Usage @close="packageDialog = false" :showCloseButton="true" />
  </fr-modal>
</template>
<script>
import { client, urls } from "@/apiClient";
import Usage from "@/modules/Billing/pages/Usage.vue";
export default {
  name: "package-list",
  props: ["selectedBrand", "billingPermissionEnabled"],
  data() {
    return {
      packageDetails: [],
      packageDialog: false,
    };
  },

  components: {
    Usage,
  },

  mounted() {
    if (this.selectedBrand?.id) {
      this.getPackagedetails();
    }
  },
  watch: {
    selectedBrand: function () {
      if (this.selectedBrand?.id) {
        this.getPackagedetails();
      }
    }
  },
  computed: {
    unifiedPackageDetails() {
      return this.packageDetails.filter((pack) => pack.enableUnifiedCredit);
    },
    nonUnifiedPackageDetails() {
      return this.packageDetails.filter((pack) => !pack.enableUnifiedCredit);
    },
  },
  methods: {
    getPackagedetails() {
      client
        .get(urls.creditsData, { params: { brandId: this.selectedBrand.id } })
        .then((response) => {
          this.packageDetails = response.data.packageList;
        });
    },
  },
};
</script>